// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__11f2o","emails":"CreateEditClinics_emails__1RDz9","emailTagLabel":"CreateEditClinics_emailTagLabel__26a3v"};